import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: () => (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 p-6 text-center">
      <p className="font-medium">Halaman tidak ditemukan.</p>
      <Link to="/" className="text-brand underline underline-offset-2">
        Kembali ke beranda
      </Link>
    </div>
  ),
});

function RootLayout() {
  return (
    <div className="flex min-h-full flex-col bg-background text-foreground">
      <Outlet />
    </div>
  );
}
